// extracted by css-extract-rspack-plugin
export default {"item":"Xvio5","itemTitle":"PBCJy","itemBullet":"raFy9"};